import { render, staticRenderFns } from "./StaticBanner.vue?vue&type=template&id=3d791aa6&scoped=true"
import script from "./StaticBanner.vue?vue&type=script&lang=js"
export * from "./StaticBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d791aa6",
  null
  
)

export default component.exports